import React from 'react';
import useFlatData from '../../../Base/Hooks/useFlatData';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import FlatList from '../../../Base/Components/FlatList';
import InsuranceExportedBatchesListItem from './InsuranceExportedBatchesListItem';
import useInsuranceReturnedBatches from '../../Hooks/useInsuranceReturnedBatches';
import styles from './InsuranceExportedBatchesList.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { DocumentationFile } from '../../../../graphql/graphql';

interface Props {
	workplaceId: string;
	rootWorkplaceId: string;
	exportFile: DocumentationFile;
}

const wrapperId = 'managerInsuranceReturnedBatchesList';

const InsuranceExportedBatchesList: React.FC<Props> = ({
	workplaceId,
	rootWorkplaceId,
	exportFile,
}) => {
	const {
		getFlatInsuranceReturnedBatches,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	} = useInsuranceReturnedBatches();

	const { flatData, hasMoreData, loadData } = useFlatData(
		getFlatInsuranceReturnedBatches,
		{
			data: data?.workplaceInsuranceBatchs?.data,
			totalPages: data?.workplaceInsuranceBatchs?.meta?.totalPages,
			page: data?.workplaceInsuranceBatchs?.meta?.page,
		},
		page,
		setPage,
		{
			workplaceId,
			exportFileId: exportFile.id,
		},
	);

	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				<LinkButton
					title='component.insuranceExportedBatchesListItem.download'
					theme={Theme.BLUE}
					href={exportFile.fileUrl}
				/>
			</div>
			<ScrollContainer wrapperId={wrapperId}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={wrapperId}
					renderItem={item => (
						<InsuranceExportedBatchesListItem
							item={item}
							rootWorkplaceId={rootWorkplaceId}
							onReload={loadData}
						/>
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default InsuranceExportedBatchesList;
